import { useMutation } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { readComplianceBody } from "../helper/readComplianceBody";
import type { DuplicateIdentityMergeDryRunResponse } from "./types";

type StoredToken = { AccessToken?: string };

export type PostDuplicateIdentityMergeDryRunPayload = {
  group_id: string;
};

const postDuplicateIdentityMergeDryRun = async (
  payload: PostDuplicateIdentityMergeDryRunPayload,
): Promise<DuplicateIdentityMergeDryRunResponse | undefined> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const url = API_ROUTES.POST_DUPLICATE_IDENTITY_MERGE_DRY_RUN.replace(
    "{group_id}",
    encodeURIComponent(payload.group_id),
  );

  const response = await PrivateAdminPanelInstance.post(url, {});
  return readComplianceBody<DuplicateIdentityMergeDryRunResponse>(response);
};

export const usePostDuplicateIdentityMergeDryRun = () => {
  return useMutation({
    mutationFn: postDuplicateIdentityMergeDryRun,
  });
};
